import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { AuthLayout, Field } from "./Login";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return toast.error("Les mots de passe ne correspondent pas");
    setBusy(true);
    try { await api.post("/auth/reset-password", { token, password: pw }); toast.success("Mot de passe réinitialisé"); navigate("/login"); }
    catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };

  if (!token) {
    return (
      <AuthLayout title="Lien invalide" subtitle="">
        <p className="text-sm text-slate-600" data-testid="reset-invalid">Ce lien est invalide ou incomplet. <Link to="/forgot-password" className="text-[#C85A32] font-semibold">Demander un nouveau lien</Link></p>
      </AuthLayout>
    );
  }
  return (
    <AuthLayout title="Nouveau mot de passe" subtitle="Choisissez un nouveau mot de passe">
      <form onSubmit={submit} className="space-y-4">
        <Field label="Nouveau mot de passe" type="password" value={pw} onChange={setPw} testid="reset-password" />
        <Field label="Confirmer le mot de passe" type="password" value={pw2} onChange={setPw2} testid="reset-password2" />
        <button disabled={busy} className="w-full bg-[#C85A32] text-white font-bold py-3 rounded-lg disabled:opacity-50" data-testid="reset-submit">{busy ? "..." : "Réinitialiser"}</button>
      </form>
    </AuthLayout>
  );
}
